import React, { useState, useEffect } from 'react';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import Sidebar from './common/Sidebar';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/solid';
import ConfirmDialog from './common/ConfirmDialog';

const Layout = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isLogoutConfirmOpen, setIsLogoutConfirmOpen] = useState(false);

    // Scroll to top when route changes
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    const handleLogout = () => {
        // Clear auth tokens/session
        localStorage.removeItem('token');
        localStorage.removeItem('authToken');
        navigate('/login');
    };

    const handleOpenLogoutConfirm = () => {
        setIsLogoutConfirmOpen(true);
    };

    const handleCloseLogoutConfirm = () => {
        setIsLogoutConfirmOpen(false);
    };

    const handleConfirmLogout = () => {
        handleLogout();
        handleCloseLogoutConfirm();
    };

    const handleMobileMenuToggle = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    const handleHomeClick = () => {
        navigate('/dashboard');
        if (isMobileMenuOpen) {
            handleMobileMenuToggle();
        }
    };

    return (
        <div className="min-h-screen bg-gray-100 lg:flex">
            <Sidebar 
                isMobileMenuOpen={isMobileMenuOpen} 
                onMobileMenuToggle={handleMobileMenuToggle} 
            />
            
            <div className="flex-1 flex flex-col">
                {/* Sticky Header for Mobile */}
                <header className="lg:hidden sticky top-0 bg-white shadow-sm z-30">
                    <div className="flex items-center justify-between px-4 py-3">
                        {/* Hamburger Button */}
                        <button
                            onClick={handleMobileMenuToggle}
                            className="text-gray-800 p-2 rounded-md hover:bg-gray-100 transition-colors"
                        >
                            {isMobileMenuOpen ? (
                                <XMarkIcon className="w-6 h-6" />
                            ) : (
                                <Bars3Icon className="w-6 h-6" />
                            )}
                        </button>
                        
                        {/* Title */}
                        <button
                            onClick={handleHomeClick}
                            className="text-lg font-semibold text-gray-900 hover:text-blue-600 transition-colors cursor-pointer"
                        >
                            HairQure Admin
                        </button>
                        
                        {/* Logout Button */}
                        <button
                            onClick={handleOpenLogoutConfirm}
                            className="px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-md"
                        >
                            Logout
                        </button>
                    </div>
                </header>

                {/* Desktop Header - Spacing and Logout */}
                <header className="hidden lg:block bg-white shadow-sm">
                    <div className="flex justify-end px-6 py-4">
                         <button
                            onClick={handleOpenLogoutConfirm}
                            className="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-md"
                        >
                            Logout
                        </button>
                    </div>
                </header>

                <main className="flex-1 p-4 lg:p-6">
                    <Outlet />
                </main>
            </div>

            {/* Logout Confirmation Dialog */}
            <ConfirmDialog
                isOpen={isLogoutConfirmOpen}
                title="Confirm Logout"
                message="Are you sure you want to logout?"
                confirmText="Logout"
                onConfirm={handleConfirmLogout}
                onCancel={handleCloseLogoutConfirm}
                confirmVariant="danger"
            />
        </div>
    );
};

export default Layout; 